import * as React from 'react';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import "./SceletonPost.scss"

const SceletonPost = () => {

    return (
        <div className='sceleton-post'>
            <Stack className='sceleton-post__content'>
                <Skeleton  className='sceleton-post__item' variant="rectangular" />
            </Stack>
        </div>
    )
}

export { SceletonPost }